import { zSchema } from "@zeal/common";

export const postSshKeyRotationGenerateRequestSchema = zSchema.object({
  state_code: zSchema.string().min(1),
  rotation_period_days: zSchema.union([
    zSchema.literal(60),
    zSchema.literal(90),
    zSchema.literal(180),
  ]),
});

export type TPostSshKeyRotationGenerateRequestSchema = zSchema.infer<
  typeof postSshKeyRotationGenerateRequestSchema
>;

export const postSshKeyRotationGenerateResponseSchema = zSchema.object({
  id: zSchema.string(),
  state_code: zSchema.string(),
  key_version: zSchema.number(),
  public_key: zSchema.string(),
  secret_manager_arn: zSchema.string(),
  status: zSchema.string(),
  rotation_period_days: zSchema.number(),
  created_at: zSchema.union([zSchema.string(), zSchema.date()]),
});

export type TPostSshKeyRotationGenerateResponseSchema = zSchema.infer<
  typeof postSshKeyRotationGenerateResponseSchema
>;
